<div
  class="grid gap-6 my-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="companyName"
      [(ngModel)]="formData.securityType"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Security type
    </label>
  </div>
</div>
<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded flex items-center justify-center"
    [disabled]="isLoading"
    (click)="onUpdate()"
  >
    <ng-container *ngIf="isLoading; else normalText">
      <span class="loader mr-2"></span> Updating...
    </ng-container>
    <ng-template #normalText>Update</ng-template>
  </button>

  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
